const supportBtn = {
  label: 'ADD'
};

export default supportBtn;
